import {Col, Divider, Form as AntForm, Row} from 'antd';
import cn from 'classnames';
import React from 'react';

import AntButton from '../AntButton/AntButton';
import FormItem from '../FormItem/FormItem';

const Form = (props) => {
    const {
        initialValues,
        onFinish,
        formFields,
        title,
        cancelButton,
        submitButton,
        closeModal,
        handleRadioChange,
        handleSelect,
        handleChange,
        handleDatePick,
        formInstance,
        customButtons,
        hiddenPattern,
        requireDeps,
        containerClassName,
        formClassName,
        formName,
        buttonsClassName,
        layout = 'vertical',
    } = props;

    return (
        <AntForm
            className={cn('flex flex-col', formClassName)}
            initialValues={initialValues}
            onFinish={onFinish}
            form={formInstance}
            layout={layout}
            name={formName || title}
            noValidate
            onValuesChange={(changedValues) => {
                const [changedFieldName] = Object.keys(changedValues);

                handleChange?.(changedValues[changedFieldName], changedFieldName);
            }}
        >
            <div className={cn('px-[56px] pt-3', containerClassName)}>
                {title && (
                    <div className='mb-8 pb-5 border-b border-divider border-opacity-60'>
                        <h2 className='font-bold text-28 text-midnight m-0 tracking-01'>{title}</h2>
                    </div>
                )}

                <Row gutter={[64, 28]}>
                    {formFields.map(({row, name, key, hidden, ...rest}, index) => {
                        const fieldProps = {
                            key,
                            name,
                            handleRadioChange,
                            handleSelect,
                            handleChange,
                            handleDatePick,
                            form: formInstance,
                            requireDeps,
                            ...rest,
                        };
                        const requireValue = AntForm.useWatch(requireDeps, formInstance);
                        const itemDepsValue = AntForm.useWatch(rest.itemDeps, formInstance);

                        const isFunction = (value) => typeof value === 'function';
                        const isHidden = isFunction(hidden) ? hidden(requireValue, itemDepsValue) : hidden;

                        const colClasses = cn('w-full', {
                            hidden: isHidden || (hiddenPattern && hiddenPattern[name]),
                        });

                        return (
                            <Col className={colClasses} span={row ? null : 12} key={key || name || index}>
                                <FormItem {...fieldProps} />
                            </Col>
                        );
                    })}
                </Row>
            </div>

            {customButtons || (
                <>
                    <Divider className='mt-[32px] mb-[24px] bg-divider opacity-30' />
                    <div className={cn('flex justify-between items-center px-[56px] pb-3', buttonsClassName)}>
                        {cancelButton && (
                            <AntButton
                                className='h-[48px] px-8 rounded-6 text-16 text-midnight font-medium bg-white border border-divider hover:border-manatee hover:bg-wild-sand transition-all duration-200'
                                onClick={closeModal}
                                type='button'
                                bordered
                                cancelHover
                            >
                                {cancelButton}
                            </AntButton>
                        )}
                        <AntButton
                            className='h-[48px] px-12 rounded-6 text-16 font-semibold shadow-button hover:shadow-float_button hover:-translate-y-[1px] transition-all duration-200'
                            type='submit'
                            htmlType='submit'
                            primary
                        >
                            {submitButton}
                        </AntButton>
                    </div>
                </>
            )}
        </AntForm>
    );
};

export default Form;
